<form class="modal-body" [formGroup]="form" (ngSubmit)="next()" novalidate>
  <p class="centermodal__title">{{ 'settings.editEmail' | translate }}</p>
  <p class="centermodal__description text-left pt-2">{{ 'settings.editEmailSubtitle' | translate }}</p>

  <div class="centermodal__form" formGroupName="user">
    <label class="field__holder" [appFormControlWrap]="form.get('user.email')">
      <input type="email" class="field" formControlName="email" name="email" autocomplete="email" required appValidEmail #emailInput />
      <span class="field__placeholder">{{ 'settings.newEmail' | translate }}</span>
    </label>

    <div class="mt-4" [class.d-none]="currentStep !== ModalStep.password">
      <div class="centermodal__group-title">{{ 'settings.fillCurrentPassword' | translate }}</div>
      <label class="field__holder" [appFormControlWrap]="form.get('user.password')">
        <input type="password" class="field" formControlName="password" name="password" autocomplete="current-password" required appShowPassword data-sentry-mask #passwordInput />
        <span class="field__placeholder">{{ 'auth.password' | translate }}</span>
      </label>
    </div>
  </div>

  <div class="centermodal__button-group">
    <button type="button" class="btn-L btn-filled-cancel" (click)="modal.dismiss()">{{ 'button.cancel' | translate }}</button>
    <button type="submit" class="btn-L btn-filled" [disabled]="isLoading || (currentStep === ModalStep.password && form.invalid)">
      {{ 'button.forward' | translate }}
    </button>
  </div>
</form>
